import $ from 'jquery';
const OPTIMAL_ZOOM = 14;
const MAX_ZOOM = 16;
const MIN_ZOOM = 5;
const CLUSTER_HEIGHT = 85;
const CLUSTER_WIDTH = 50;
const CLUSTERER_STYLE = [
	{
		textColor: '#791D81',
		textSize: 12,
		anchor: [35, 0],
		url: '/static/assets/img/cluster.svg',
		height: CLUSTER_HEIGHT,
		width: CLUSTER_WIDTH
	}, {
		textColor: '#791D81',
		textSize: 12,
		anchor: [35, 0],
		url: '/static/assets/img/cluster.svg',
		height: CLUSTER_HEIGHT,
		width: CLUSTER_WIDTH
	}, {
		textColor: '#791D81',
		textSize: 12,
		anchor: [35, 0],
		url: '/static/assets/img/cluster.svg',
		height: CLUSTER_HEIGHT,
		width: CLUSTER_WIDTH
	}, {
		textColor: '#791D81',
		textSize: 12,
		anchor: [35, 0],
		url: '/static/assets/img/cluster.svg',
		height: CLUSTER_HEIGHT,
		width: CLUSTER_WIDTH
	}, {
		textColor: '#791D81',
		textSize: 12,
		anchor: [35, 0],
		url: '/static/assets/img/cluster.svg',
		height: CLUSTER_HEIGHT,
		width: CLUSTER_WIDTH
	}];
var vm;

export const RealEstateSearchResultMapComponent = {
	bindings: {
		realEstateList: '<'
	},
	templateUrl: 'real-estate-search-result-map.html',
	controller: class RealEstateSearchResultMapComponent {
		constructor(NgMap, $timeout, $scope, $filter, $rootScope, CommonConstants, favouriteService, loginService) {
			'ngInject';
			vm = this;
			this.ngMap = NgMap;
			this.$timeout = $timeout;
			this.$scope = $scope;
			this.$filter = $filter;
			this.$rootScope = $rootScope;
			this.markers = [];
			this.constants = CommonConstants;
			this.favouriteService = favouriteService;
			this.loginService = loginService;
			this.likes = {};
			this.$scope.$on('estateLikedToList', (e, info) => {
				if (this.selectedEstate) {
					if (this.selectedEstate.comissionId == info.id) {
						this.selectedEstate.liked = info.liked;
					}
				}
				this.likes[info.id] = info.liked;
			});
			this.$scope.$on('showInfoWindow', (e, item) => {
				this.markerClicked(e, item);
			});
		}

		$onInit() {
			this.$scope.$on('mapResize', (event, data) => {
				this.ngMap.getMap().then((map) => {
					google.maps.event.trigger(map, 'resize');
				});
			});
			this.ngMap.getMap({ id: 'search-result-map' }).then(function (map) {
				vm.map = map;
				window.google.maps.event.addListenerOnce(vm.map, 'tilesloaded', function () {
					vm.map.mapLoaded = true;
					vm.initMap();
				});
			});
		}

		$onChanges() {
			if (this.realEstateList && this.realEstateList.length) {

				// térkép frissülés miatt
				this.$timeout(() => {
					vm.list = [];
					vm.list = angular.copy(vm.realEstateList);
					if (vm.map) {
						vm.hideMap = true;
						vm.$timeout(() => {
							vm.hideMap = false;
						}).then(() => {
							vm.ngMap.getMap({ id: 'search-result-map' }).then(function (map) {
								vm.map = map;
								vm.initMap();
							});
						});
					}
				});
			}
		}

		initMap() {
			vm.clearMarkers().then(() => {
				vm.setMapBounds();
			});
		}

		setMapBounds() {
			let mapBounds = new window.google.maps.LatLngBounds();
			if (vm.map.markers && Object.keys(vm.map.markers).length) {
				for (let key in vm.map.markers) {
					let elem = vm.map.markers[key];
					let position = elem.getPosition();
					mapBounds.extend(position);
					vm.markers.push(elem);
				}
				if (vm.markerClusterer) {
					vm.markerClusterer.clearMarkers();
				}
				vm.markerClusterer = vm.createMarkerClusterer();
				vm.map.setCenter(mapBounds.getCenter());
				vm.map.fitBounds(mapBounds);
				vm.checkZoom();
			}
		}

		createMarkerClusterer() {
			return new window.MarkerClusterer(vm.map, this.markers, {
				styles: CLUSTERER_STYLE,
				maxZoom: 12
			});
		}

		clearMarkers() {
			return new Promise((resolve, reject) => {
				// marker törlése clusterező miatt
				if (this.markers.length) {
					for (let i = 0; i < this.markers.length; i++) {
						this.markers[i].setMap(null);
					}
					this.markers.length = 0;
				}
				// elvileg ngMap markerek törlése
				if (this.map.markers && Object.keys(this.map.markers).length) {
					for (var key in this.map.markers) {
						this.map.markers[key].setMap(null);
					}
				}
				resolve();
			});
		}

		checkZoom() {
			if (vm.map.getZoom() > OPTIMAL_ZOOM) {
				vm.map.setZoom(OPTIMAL_ZOOM);
			}
		}

		// Térképes függvényeknél a 'this' a maps direktíva kontrollere!
		mapChanged() {
			vm.map.mapLoaded = true;
			vm.mapZoom = vm.map.getZoom();
			if (vm.map.getZoom() > MAX_ZOOM) {
				vm.map.setZoom(MAX_ZOOM);
			}
			if (vm.map.getZoom() < MIN_ZOOM) {
				vm.map.setZoom(MIN_ZOOM);
			}
			if (!vm.map.showSearchButton) {
				vm.map.showSearchButton = true;
			}
		}

		getMarkerUrl(estate) {
			return {
				url: estate.seen ? '/static/assets/img/pin-seen.svg' : '/static/assets/img/pin.svg'
			};
		}

		getHiddenMarkerUrl(estate) {
			if (estate.seen) {
				return {
					url: this.mapZoom > 12 ? '/static/assets/img/transparent.png' : '/static/assets/img/pin-hidden-seen.svg'
				};
			} else {
				return {
					url: this.mapZoom > 12 ? '/static/assets/img/transparent.png' : '/static/assets/img/pin-hidden.svg'
				};
			}
		}

		getShapeColor(estate) {
			return estate.seen ? '#3999CA' : '#52AE30';
		}
		getFillOpacity(estate) {
			return (this.selectedEstate && this.selectedEstate.comissionId == estate.comissionId) ? 1 : 0;
		}
		markerClicked(event, estate) {
			if (vm.map && vm.map.markers && vm.map.markers[estate.comissionId]) {
				vm.selectedEstate = estate;
				vm.checkLiked();
				window.dataLayer.push({
					event: 'propertyMapClick',
					propertyID: estate.comissionId
				});
				vm.map.showInfoWindow('info', estate.comissionId);
				vm.$timeout(() => {
					vm.initLazySlider();
				}, 500);
			}
			if (vm.map && vm.map.shapes && vm.map.shapes[estate.comissionId]) {
				Object.keys(vm.map.shapes).forEach(((shapeKey)=>{
					vm.map.shapes[shapeKey].set('fillOpacity', '0');
				}));
				vm.map.shapes[estate.comissionId].set('fillOpacity', '0.35');
			}
		}
		markerMouseOver(event, estate) {
			if (vm.map && vm.map.shapes && vm.map.shapes[estate.comissionId]) {
				vm.map.shapes[estate.comissionId].set('fillOpacity', '0.35');
			}
		}
		markerMouseOut(event, estate) {
			if (vm.map && vm.map.shapes && vm.map.shapes[estate.comissionId] && (!vm.selectedEstate || vm.selectedEstate.comissionId != estate.comissionId )) {
				vm.map.shapes[estate.comissionId].set('fillOpacity', '0');
			}
		}
		initLazySlider() {
			vm.lazyBgImg(true, 0);
			$('.slick-slider--infow-indow').on('beforeChange', (event, slick, slide, nextSlide) => {
				if (slide != nextSlide) {
					vm.lazyBgImg($(slick.$slides.get(nextSlide)), nextSlide);
				}
			});
		}

		lazyBgImg(element, nextSlide) {
			if (element) {
				let lazyBgImgs = angular.element('.info-slick_' + nextSlide);
				$.each(lazyBgImgs, function (index, el) {
					$(el).css('background-image', 'url(' + vm.selectedEstate.images[nextSlide].url + ')');
				});
			}
		}

		mapClick() {
			vm.map.hideInfoWindow('info');
			vm.selectedEstate = null;
		}

		checkLiked() {
			for (let key in vm.likes) {
				if (key == vm.selectedEstate.comissionId) {
					vm.selectedEstate.liked = vm.likes[key];
				}
			}
		}

		// kedvencelés
		setLiked() {
			this.favouriteService.setFavourite(vm.selectedEstate.comissionId).then((response) => {
				vm.selectedEstate.liked = !vm.selectedEstate.liked;
				vm.$scope.$emit('estateLiked', {
					id: vm.selectedEstate.comissionId,
					liked: vm.selectedEstate.liked
				});
			}).catch((error) => {
				console.log(error);
			});
		}

		// loginolás
		showLogin($event) {
			this.loginService.openLoginForm($event);
		}
	}
};
